import { Line } from 'react-chartjs-2';
import { ShiftFeedbackRating } from '@sdk/timesheets/types/ShiftFeedback';

import './chartjsRegister';
import { LineGraphContainer } from './lineGraphComponent.styles';
import { LineGraphTooltip } from './LineGraphTooltip';
import { useLineGraph, DataPoint } from './lineGraphComponent.hooks';

export type Props = {
  data: DataPoint[];
  ratingsFilter: ShiftFeedbackRating[];
  chartsScaleFactor: number;
};

export const LineGraphComponent = ({ data, ratingsFilter, chartsScaleFactor }: Props) => {
  const { chartData, options, plugins, tooltipData } = useLineGraph(data, chartsScaleFactor);

  return (
    <LineGraphContainer style={{ height: 200 }}>
      <Line data={chartData} options={options} plugins={plugins} />
      <LineGraphTooltip {...tooltipData} ratingsFilter={ratingsFilter} />
    </LineGraphContainer>
  );
};
